/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Honor_2_Item_1_DetailInputs */

const en_about_content_honor_2_item_1_detail = /** @type {(inputs: About_Content_Honor_2_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range`)
};

const es_about_content_honor_2_item_1_detail = /** @type {(inputs: About_Content_Honor_2_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range`)
};

const de_about_content_honor_2_item_1_detail = /** @type {(inputs: About_Content_Honor_2_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range`)
};

const zh_about_content_honor_2_item_1_detail = /** @type {(inputs: About_Content_Honor_2_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`得梅因练习场`)
};

const ar_about_content_honor_2_item_1_detail = /** @type {(inputs: About_Content_Honor_2_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range`)
};

const fr_about_content_honor_2_item_1_detail = /** @type {(inputs: About_Content_Honor_2_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range`)
};

const vi_about_content_honor_2_item_1_detail = /** @type {(inputs: About_Content_Honor_2_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range`)
};

const sw_about_content_honor_2_item_1_detail = /** @type {(inputs: About_Content_Honor_2_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range`)
};

const th_about_content_honor_2_item_1_detail = /** @type {(inputs: About_Content_Honor_2_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สนามไดร์ฟกอล์ฟดิมอยน์`)
};

const bs_about_content_honor_2_item_1_detail = /** @type {(inputs: About_Content_Honor_2_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range`)
};

const ja_about_content_honor_2_item_1_detail = /** @type {(inputs: About_Content_Honor_2_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デモイン・ドライビングレンジ`)
};

const ko_about_content_honor_2_item_1_detail = /** @type {(inputs: About_Content_Honor_2_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range`)
};

const pt_about_content_honor_2_item_1_detail = /** @type {(inputs: About_Content_Honor_2_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range`)
};

const it_about_content_honor_2_item_1_detail = /** @type {(inputs: About_Content_Honor_2_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range`)
};

const sv_about_content_honor_2_item_1_detail = /** @type {(inputs: About_Content_Honor_2_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range`)
};

const nl_about_content_honor_2_item_1_detail = /** @type {(inputs: About_Content_Honor_2_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range`)
};

const da_about_content_honor_2_item_1_detail = /** @type {(inputs: About_Content_Honor_2_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range`)
};

const nb_about_content_honor_2_item_1_detail = /** @type {(inputs: About_Content_Honor_2_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range`)
};

const fi_about_content_honor_2_item_1_detail = /** @type {(inputs: About_Content_Honor_2_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range`)
};

const pl_about_content_honor_2_item_1_detail = /** @type {(inputs: About_Content_Honor_2_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range`)
};

const ru_about_content_honor_2_item_1_detail = /** @type {(inputs: About_Content_Honor_2_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range`)
};

const tr_about_content_honor_2_item_1_detail = /** @type {(inputs: About_Content_Honor_2_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range`)
};

const hi_about_content_honor_2_item_1_detail = /** @type {(inputs: About_Content_Honor_2_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range`)
};

const id_about_content_honor_2_item_1_detail = /** @type {(inputs: About_Content_Honor_2_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range`)
};

const ms_about_content_honor_2_item_1_detail = /** @type {(inputs: About_Content_Honor_2_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range`)
};

const cs_about_content_honor_2_item_1_detail = /** @type {(inputs: About_Content_Honor_2_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range`)
};

const el_about_content_honor_2_item_1_detail = /** @type {(inputs: About_Content_Honor_2_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range`)
};

const he_about_content_honor_2_item_1_detail = /** @type {(inputs: About_Content_Honor_2_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range`)
};

const af_about_content_honor_2_item_1_detail = /** @type {(inputs: About_Content_Honor_2_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range`)
};

const hu_about_content_honor_2_item_1_detail = /** @type {(inputs: About_Content_Honor_2_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range`)
};

/**
* | output |
* | --- |
* | "Des Moines Driving Range" |
*
* @param {About_Content_Honor_2_Item_1_DetailInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_honor_2_item_1_detail = /** @type {((inputs?: About_Content_Honor_2_Item_1_DetailInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Honor_2_Item_1_DetailInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_honor_2_item_1_detail(inputs)
	if (locale === "de") return de_about_content_honor_2_item_1_detail(inputs)
	if (locale === "zh") return zh_about_content_honor_2_item_1_detail(inputs)
	if (locale === "ar") return ar_about_content_honor_2_item_1_detail(inputs)
	if (locale === "fr") return fr_about_content_honor_2_item_1_detail(inputs)
	if (locale === "vi") return vi_about_content_honor_2_item_1_detail(inputs)
	if (locale === "sw") return sw_about_content_honor_2_item_1_detail(inputs)
	if (locale === "th") return th_about_content_honor_2_item_1_detail(inputs)
	if (locale === "bs") return bs_about_content_honor_2_item_1_detail(inputs)
	if (locale === "ja") return ja_about_content_honor_2_item_1_detail(inputs)
	if (locale === "ko") return ko_about_content_honor_2_item_1_detail(inputs)
	if (locale === "pt") return pt_about_content_honor_2_item_1_detail(inputs)
	if (locale === "it") return it_about_content_honor_2_item_1_detail(inputs)
	if (locale === "sv") return sv_about_content_honor_2_item_1_detail(inputs)
	if (locale === "nl") return nl_about_content_honor_2_item_1_detail(inputs)
	if (locale === "da") return da_about_content_honor_2_item_1_detail(inputs)
	if (locale === "nb") return nb_about_content_honor_2_item_1_detail(inputs)
	if (locale === "fi") return fi_about_content_honor_2_item_1_detail(inputs)
	if (locale === "pl") return pl_about_content_honor_2_item_1_detail(inputs)
	if (locale === "ru") return ru_about_content_honor_2_item_1_detail(inputs)
	if (locale === "tr") return tr_about_content_honor_2_item_1_detail(inputs)
	if (locale === "hi") return hi_about_content_honor_2_item_1_detail(inputs)
	if (locale === "id") return id_about_content_honor_2_item_1_detail(inputs)
	if (locale === "ms") return ms_about_content_honor_2_item_1_detail(inputs)
	if (locale === "cs") return cs_about_content_honor_2_item_1_detail(inputs)
	if (locale === "el") return el_about_content_honor_2_item_1_detail(inputs)
	if (locale === "he") return he_about_content_honor_2_item_1_detail(inputs)
	if (locale === "af") return af_about_content_honor_2_item_1_detail(inputs)
	if (locale === "hu") return hu_about_content_honor_2_item_1_detail(inputs)
	return en_about_content_honor_2_item_1_detail(inputs)
});